import { render, staticRenderFns } from "./dataSourceSort.vue?vue&type=template&id=41d20e40&scoped=true"
import script from "./dataSourceSort.vue?vue&type=script&lang=ts"
export * from "./dataSourceSort.vue?vue&type=script&lang=ts"
import style0 from "./dataSourceSort.vue?vue&type=style&index=0&id=41d20e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d20e40",
  null
  
)

export default component.exports